import React, { useContext, useEffect, useState } from 'react';

import cx from 'classnames';

import { FLIGHT_TYPE } from 'components/Pages/Admin/GuestPortal/Flights/constants';
import { FlightsContext } from 'components/Pages/Admin/GuestPortal/Flights/context';
import FormTitle from 'components/shared/Typography/FormTitle';
import { isInternalItem } from 'store/itinerariesItem';

import { FlightNumber } from './FlightNumber';
// import { RecordLocator } from './RecordLocator';
import s from './index.module.css';
import { Result } from './Result';
import { Route } from './Route';
import { Actions, Footer } from './shared';
import { FLIGNT_NUMBER, getFsSearchType, getFsSearchTypeDefault, getUniqueFlightAPIKey, ROUTE, types } from './utils';

export function AddFlights(props) {
  const { itemIndex, currentItem } = props;
  const [activeType, setActiveType] = useState(types[0]);
  const [activeItemsHash, setActiveItemsHash] = React.useState(
    // If it is edit -> we set null value to the selected flight to update it later in the search
    currentItem ? { [getUniqueFlightAPIKey(currentItem)]: null } : {},
  );
  const [dateValue, setDateValue] = React.useState(null);
  const [isNotifyAgentChecked, setIsNotifyAgentChecked] = useState(currentItem?.notifyAgent ?? true);
  const [isUpdateClientSideChecked, setIsUpdateClientSideChecked] = useState(currentItem?.updateClientSide ?? true);
  const {
    scheduledFlights,
    handleSaveData,
    closeModal,
    submitting,
    handleCheckLastItem,
    needCheckEditedItem,
    handleItemEdit,
  } = useContext(FlightsContext);

  const isEdit = Boolean(currentItem) && !isInternalItem(currentItem);
  const handleSetType = (enteredType) => setActiveType(enteredType);

  const handleNotifyAgent = () => setIsNotifyAgentChecked((prev) => !prev);
  const handleUpdateClientSide = () => setIsUpdateClientSideChecked((prev) => !prev);

  const addFlights = async (checkedValues) => {
    const flights = checkedValues.filter(Boolean).map((el) => ({
      ...el,
      type: FLIGHT_TYPE,
      fromFsService: true,
      fsSearchType: getFsSearchType(activeType),
      id: isEdit ? currentItem.id : undefined,
      notifyAgent: isNotifyAgentChecked,
      updateClientSide: isUpdateClientSideChecked,
    }));

    if (isEdit) {
      flights[0].force_update_flight = true;
      await handleItemEdit(flights[0]);
      needCheckEditedItem(flights[0].id);
    } else {
      await handleSaveData({ itemIndex, newItem: flights });
      handleCheckLastItem();
    }
    closeModal();
  };

  useEffect(() => {
    if (isEdit && currentItem?.fsSearchType) setActiveType(getFsSearchTypeDefault(currentItem.fsSearchType));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={cx(s.container, 'custom-add-flights-container')}>
      <FormTitle center>Add a Flight to Your Itinerary</FormTitle>

      <Actions activeType={activeType} handleSetType={handleSetType} types={types} isEdit={isEdit} />

      <div className={cx(s.form, 'custom-add-flights-form')}>
        {activeType === FLIGNT_NUMBER && (
          <FlightNumber
            {...props}
            dateValue={dateValue}
            setDateValue={setDateValue}
            activeItems={activeItemsHash}
            setActiveItems={setActiveItemsHash}
            isNotifyAgentChecked={isNotifyAgentChecked}
            isUpdateClientSideChecked={isUpdateClientSideChecked}
            setIsNotifyAgentChecked={handleNotifyAgent}
            setIsUpdateClientSideChecked={handleUpdateClientSide}
          />
        )}
        {/* {activeType === 'Record Locator' && <RecordLocator {...props} setActiveItem={setActiveItem} />} */}
        {activeType === ROUTE && (
          <Route
            {...props}
            dateValue={dateValue}
            setDateValue={setDateValue}
            activeItems={activeItemsHash}
            setActiveItems={setActiveItemsHash}
            isNotifyAgentChecked={isNotifyAgentChecked}
            isUpdateClientSideChecked={isUpdateClientSideChecked}
            setIsNotifyAgentChecked={handleNotifyAgent}
            setIsUpdateClientSideChecked={handleUpdateClientSide}
          />
        )}
      </div>

      <Result
        data={scheduledFlights}
        activeType={activeType}
        onAdd={addFlights}
        submitting={submitting}
        activeItems={activeItemsHash}
        setActiveItems={setActiveItemsHash}
      />

      {!isEdit && <Footer {...props} />}
    </div>
  );
}
